import React from "react";
import FontBody1 from "../../../../../fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../fonts/font-props";
import { automation } from "../../../../../../utils/automation";

type CurrentPortalProps = {
	portalName: string;
	secondaryPortalName?: string;
}

const CurrentPortal: React.FC<CurrentPortalProps> = ({portalName, secondaryPortalName}) => {
	return (
		<>
			<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
				<span
					{...automation({
						base: 'portal-select--main-portal-name',
						value: portalName
					})}
				>
					{portalName}
				</span>
			</FontBody1>
			{secondaryPortalName && (
				<FontBody1>
					<span
						{...automation({
							base: 'portal-select--secondary-portal-name',
							value: portalName
						})}
					>
						&nbsp;•&nbsp;{secondaryPortalName}
					</span>
				</FontBody1>
			)}
		</>
	)
}

export default CurrentPortal;